// @flow

import _ from 'lodash';

import {takeExtension, takeFilename, takeDir, ms_regex, culti_regex} from './utils.js';



export const T_DIR     :   1 =   1;
export const T_CULTI   :   2 =   2;
export const T_MAV     :   4 =   4;
export const T_MS      :   8 =   8;
export const T_PNG     :  16 =  16;
export const T_OBS     :  32 =  32;
export const T_PM      :  64 =  64;
export const T_UNKNOWN : 128 = 128;


export type T_Kind =
  typeof T_DIR     |
  typeof T_CULTI   |
  typeof T_MAV     |
  typeof T_MS      |
  typeof T_PNG     |
  typeof T_OBS     |
  typeof T_PM      |
  typeof T_UNKNOWN ;


export function show_cod(cod: T_Kind): string {
  if      (cod === T_DIR)   return 'T_DIR';
  else if (cod === T_CULTI) return 'T_CULTI';
  else if (cod === T_MS)    return 'T_MS';
  else if (cod === T_MAV)   return 'T_MAV';
  else if (cod === T_PNG)   return 'T_PNG';
  else if (cod === T_OBS)   return 'T_OBS';
  else if (cod === T_PM)    return 'T_PM';
  
  return 'T_UNKNOWN';
}



export function takeCod(path: string): T_Kind {
  const ext  = takeExtension(path),
        file = takeFilename(path);
  
  if (ext === 'png')
    return T_PNG;
  
  if (ext === 'shp') {
    if (file.indexOf('ms_0000') === 0 || file.indexOf('pm') === 0) {
      return T_PM;
    }
    if (file.match(ms_regex)) {
      return T_MS;
    }
    else if (file.match(culti_regex)) {
      return T_CULTI;
    }
    else if (file.indexOf('mav_') === 0) {
      return T_MAV;
    }
  }
  
  if (ext === 'nota') {
    return T_OBS;
  }
  
  return T_UNKNOWN;   // NOTE: CANT TELL IF T_DIR OR T_UNKNOWN. USE ME ONLY IN THINGS WITH EXTENSION
}



export function highest_shps(ss: Array<string>): Array<string> {
  const gs = _.values(_.groupBy(ss, takeDir)),
        rs = [];
  
  gs.forEach((group) => {
    const culti = _.find(group, path => takeCod(path) === T_CULTI);
    
    if (culti) {
      rs.push(culti);
    }
    else {
      const mav = _.find(group, path => takeCod(path) === T_MAV);
      
      if (mav) {
        rs.push(mav);
      }
      else {
        const ms = _.find(group, path => takeCod(path) === T_MS);
        
        if (ms) rs.push(ms);
      }
    }
  });
  
  return rs;
}



export function has_low_priority(path: string, shp_paths: Array<string>): boolean {
  const dir = takeDir(path),
        cod = takeCod(path);
  
  return _.filter(shp_paths, shp_path => takeDir(shp_path) === dir && takeCod(shp_path) < cod).length > 0;
}




// WEBPACK FOOTER //
// ./src/codtype.js